import kfext from '../kfext';

function searchCloudPhoneBook(params) {
    return Vue.prototype.$_sAjax.get('/cc/callContacts/GetListByGid', {
        params
    });
}

export default function(config) {
    const selfConfig = config;
    const params = {
        selectKfext: selfConfig.userId || kfext.getCurrentId(),
        groupId: -1,
        page: config.pageIndex ? Number(config.pageIndex) + 1 : 0,
        pageSize: 999,
        searchValue: config.name
    };
    return new Promise((resolve, reject) => {
        searchCloudPhoneBook(params).then(
            res => {
                if (res.data.list && res.data.list.length) {
                    const list = res.data.list.map(x => {
                        return {
                            ...x,
                            face: x.avatar,
                            extend: {
                                dbId: x.id
                            },
                            id: x.qq[0]
                        };
                    });
                    resolve({
                        list
                    });
                } else {
                    resolve({
                        list: []
                    });
                }
            },
            err => {
                reject(err);
            }
        );
    });
}
